// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"594":"demo","758":"dome"}[chunkId] || chunkId) + "." + {"112":"0131749e","594":"3106b04a","758":"3560c39d"}[chunkId] + ".css";
};